import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const ChainlockBikerPants = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.ChainlockBikerPants.itemName}
      name={SS23.pants.ChainlockBikerPants.itemName}
      price={SS23.pants.ChainlockBikerPants.itemPrice}
      fabric={SS23.pants.ChainlockBikerPants.itemFabric}
      src={SS23.pants.ChainlockBikerPants.sizeChart}
      divId={SS23.pants.ChainlockBikerPants.shopifyDivId}
      mainId={SS23.pants.ChainlockBikerPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.ChainlockBikerPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.ChainlockBikerPants.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default ChainlockBikerPants;
